import { useCallback } from 'react';
import { flagParam } from '../utils/urlParams';
import { useUrlState } from './useUrlState';

// "Show details": whether a page shows everything or only its headline. It is kept in the address as
// ?details=1, so a reload and a copied link open the same view; the default (headline only) is left out.
export function useDetails(key = 'details'): [boolean, (open: boolean) => void] {
  const { params, update } = useUrlState();
  const open = flagParam(params, key);
  const setOpen = useCallback((next: boolean) => update({ [key]: next ? '1' : null }), [update, key]);
  return [open, setOpen];
}
